import * as moment from 'moment-timezone';

/**
 * The zone the device is set to. It answers a different question from TenantTimezone: that one is
 * what the app renders in, this one is what the clock in the user's hand reads. The only reason to
 * ask is to decide whether an hour we paint needs telling apart from the user's own.
 */
export class DeviceTimezone {
  static current(): string {
    return moment.tz.guess();
  }
}
